// extracted by mini-css-extract-plugin
export default {"darkBodyBackground":"styles_darkBodyBackground__Tv8Vl","whiteBodyBackground":"styles_whiteBodyBackground__d9eFU","dark":"styles_dark__G0cRx","white":"styles_white__M5ahH"};